module.exports = __webpack_public_path__ + "img/p_18.7630d171.png";